import {
  ACCOUNT_DELETION_DAYS,
  ADMIN_NAME,
  APP_NAME,
  CONTACT_EMAIL,
  CONTACT_MAILTO,
} from "../../lib/contact";
import { PublicChrome } from "./PublicChrome";

export function PrivacyPage() {
  return (
    <PublicChrome>
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16" data-testid="privacy-page">
        <p className="text-sm font-bold uppercase tracking-wide text-brand">Informacje prawne</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
          Polityka prywatności aplikacji {APP_NAME}
        </h1>
        <p className="mt-4 text-sm text-muted">Ostatnia aktualizacja: 31 sierpnia 2026 r.</p>

        <div className="mt-10 space-y-10 text-base leading-relaxed">
          <section>
            <h2 className="text-xl font-bold">1. Postanowienia ogólne</h2>
            <dl className="mt-4 space-y-3 text-muted">
              <div>
                <dt className="font-semibold text-ink">Administrator Danych</dt>
                <dd className="mt-1">
                  Administratorem danych osobowych jest {ADMIN_NAME}, kontakt:{" "}
                  <a className="font-semibold text-brand hover:underline" href={CONTACT_MAILTO}>
                    {CONTACT_EMAIL}
                  </a>{" "}
                  (dalej: „Administrator”).
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Cel dokumentu</dt>
                <dd className="mt-1">
                  Polityka określa zasady przetwarzania danych użytkowników (hodowców) oraz danych
                  pobieranych z systemu IRZPlus.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Podstawa prawna</dt>
                <dd className="mt-1">
                  Dane są przetwarzane zgodnie z Rozporządzeniem RODO (UE 2016/679).
                </dd>
              </div>
            </dl>
          </section>

          <section>
            <h2 className="text-xl font-bold">2. Zakres i cel zbierania danych</h2>
            <div className="mt-4 space-y-4 text-muted">
              <div>
                <h3 className="font-semibold text-ink">Rejestracja konta</h3>
                <p className="mt-2">
                  Przetwarzamy wyłącznie Twój adres e-mail.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Cel rejestracji</h3>
                <p className="mt-2">
                  Założenie konta, weryfikacja tożsamości, resetowanie hasła oraz kontakt z
                  Administratorem.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Podstawa prawna</h3>
                <p className="mt-2">
                  Umowa o świadczenie usług drogą elektroniczną (art. 6 ust. 1 lit. b RODO).
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Dane wprowadzane w aplikacji</h3>
                <p className="mt-2">
                  Możesz samodzielnie zapisywać dane stada (zwierzęta, stanówki, wykoty, kolczyki,
                  kontrole, finanse). Przetwarzamy je wyłącznie w celu świadczenia usługi (art. 6
                  ust. 1 lit. b RODO).
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">3. Integracja z systemem IRZPlus (ARiMR)</h2>
            <div className="mt-4 space-y-4 text-muted">
              <div>
                <h3 className="font-semibold text-ink">Bezpieczeństwo logowania</h3>
                <p className="mt-2">
                  Aplikacja umożliwia bezpośrednie logowanie do systemu IRZPlus.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Brak zapisu haseł</h3>
                <p className="mt-2">
                  Dane logowania (login, hasło) do IRZPlus nie są zapisywane, przechowywane ani
                  cache&apos;owane na serwerach Administratora ani w pamięci aplikacji po zakończeniu
                  sesji.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Pobieranie danych</h3>
                <p className="mt-2">
                  Na wyraźne zlecenie użytkownika aplikacja pobiera dane z IRZPlus, w tym:
                </p>
                <ul className="mt-2 list-disc space-y-1 pl-5">
                  <li>Dane zwierząt (numery kolczyków, rasa, płeć, historia zdarzeń).</li>
                  <li>Dane gospodarstwa (numer producenta ARiMR, numer siedziby stada).</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Cel przetwarzania</h3>
                <p className="mt-2">
                  Umożliwienie lokalnego zarządzania stadem i przeglądania danych w wygodnym
                  interfejsie aplikacji.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">4. Przechowywanie i odbiorcy danych</h2>
            <div className="mt-4 space-y-4 text-muted">
              <div>
                <h3 className="font-semibold text-ink">Infrastruktura</h3>
                <p className="mt-2">
                  Dane aplikacji są przechowywane na bezpiecznych serwerach w chmurze dostarczanych
                  przez OVHcloud (OVH SAS) na terenie Unii Europejskiej.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Obsługa poczty</h3>
                <p className="mt-2">
                  Twój adres e-mail jest przetwarzany przez system pocztowy OVHcloud wyłącznie w
                  celu wysyłki wiadomości systemowych (weryfikacja, odzyskiwanie hasła).
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-ink">Zakaz udostępniania</h3>
                <p className="mt-2">
                  Dane nie są sprzedawane ani udostępniane żadnym innym firmom trzecim ani
                  partnerom marketingowym.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">5. Okres przechowywania danych</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Dane konta (e-mail) oraz pobrane dane z IRZPlus są przechowywane przez okres
                aktywności konta użytkownika.
              </p>
              <p>
                W przypadku podjęcia decyzji o usunięciu konta możesz złożyć wniosek samodzielnie
                w ustawieniach aplikacji (sekcja „Strefa niebezpieczna”) lub mailowo na adres{" "}
                <a className="font-semibold text-brand hover:underline" href={CONTACT_MAILTO}>
                  {CONTACT_EMAIL}
                </a>
                . Wszystkie powiązane dane są trwale usuwane z serwerów OVHcloud w ciągu{" "}
                {ACCOUNT_DELETION_DAYS} dni od złożenia wniosku — w tym czasie możesz anulować
                operację linkiem wysłanym na e-mail.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">6. Prawa użytkownika</h2>
            <p className="mt-4 text-muted">Każdemu użytkownikowi przysługuje prawo do:</p>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-muted">
              <li>Wglądu w swoje dane oraz pobrania ich kopii.</li>
              <li>Sprostowania lub poprawienia danych.</li>
              <li>Żądania usunięcia danych („prawo do bycia zapomnianym”).</li>
              <li>Ograniczenia przetwarzania.</li>
              <li>
                Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (
                <a
                  className="font-semibold text-brand hover:underline"
                  href="https://uodo.gov.pl/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  PUODO
                </a>
                ).
              </li>
            </ul>
            <p className="mt-4 text-muted">
              Wnioski dotyczące praw RODO kieruj na{" "}
              <a className="font-semibold text-brand hover:underline" href={CONTACT_MAILTO}>
                {CONTACT_EMAIL}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold">7. Pliki cookies i dane techniczne</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Aplikacja przetwarza podstawowe, techniczne dane sesyjne niezbędne do utrzymania
                zalogowanego użytkownika (cookie sesji oraz token ochrony CSRF).
              </p>
              <p>
                Nie stosujemy skryptów śledzących zachowanie (takich jak Google Analytics czy
                Facebook Pixel).
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">8. Przyszłe płatności</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Administrator planuje wprowadzenie płatnych planów subskrypcyjnych. Do obsługi
                płatności może zostać wykorzystany zewnętrzny operator (procesor płatności), który
                może przetwarzać dane poza Europejskim Obszarem Gospodarczym — w takim przypadku
                zastosowane zostaną odpowiednie zabezpieczenia prawne (np. standardowe klauzule
                umowne).
              </p>
              <p>
                Szczegółowe informacje o procesorze płatności zostaną uzupełnione w polityce
                prywatności przed uruchomieniem płatności.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">9. Zmiany w polityce prywatności</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Administrator zastrzega sobie prawo do aktualizacji polityki w przypadku rozwoju
                aplikacji (np. wprowadzenia płatności).
              </p>
              <p>O zmianach użytkownicy zostaną poinformowani drogą mailową lub wewnątrz aplikacji.</p>
            </div>
          </section>
        </div>
      </main>
    </PublicChrome>
  );
}
